import { useCallback } from 'react'
import { useStore } from 'react-redux'
import type { Persistor } from 'redux-persist'

export default function useReloadPage(): () => Promise<void> {
  // `__persistor` is the hack `makeStore` hangs on the store; see `store.ts`.
  const store = useStore() as { __persistor?: Persistor }

  return useCallback(async (): Promise<void> => {
    // Persisted slices are written lazily, so a reload straight after a dispatch would restore the old values.
    await store.__persistor?.flush()
    window.location.reload()
  }, [store])
}
